import { motion } from 'framer-motion';
import { BrowserRouter } from 'react-router-dom';
import './App.css';
import AppRoutes from './Router/router';
import ScrollTop from './ScrollToTop';      // ✅ keep only this one
import Footer from './components/Footer';
import Header from './components/Header';
import UniversalHomeButton from './components/UI/UniversalHomeButton';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  return (
    <div className="relative font-sans text-gray-800 bg-white min-h-screen flex flex-col">
      <BrowserRouter>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4 }}
        >
          <main className="flex-grow">
            <ScrollTop />               {/* ✅ only one scroll component */}
            <UniversalHomeButton />
            <Header />
            <AppRoutes />
          </main>
        </motion.div>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;